export const createFormatter = options => ({ value }) => {
  const labels = options
    .filter(option => value.includes(option.key))
    .map(option => option.label);

  return labels.join(', ');
};
